import buildConfig from "../../buildConfig";

const initGDSdk = ({
    onGamePause, onGameStart
                   }) => {

    if (buildConfig.gd) {
        window.onGamePause = onGamePause;
        window.onGameStart = onGameStart;
    }
}

export default initGDSdk;